import { render } from "./InventorySalesHistory.vue?vue&type=template&id=6fa0199c&scoped=true"
import script from "./InventorySalesHistory.vue?vue&type=script&lang=js"
export * from "./InventorySalesHistory.vue?vue&type=script&lang=js"

import "./InventorySalesHistory.vue?vue&type=style&index=0&id=6fa0199c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa0199c"]])

export default __exports__